export default class WebCamModal {

    /**
     * @type {HTMLElement}
     */
    modal;

    /**
     * @type {HTMLElement[]}
     */
    modalButtons = [];

    /**
     * @type {HTMLElement}
     */
    contentElement;

    /**
     * @type {HTMLIFrameElement}
     */
    iframe;

    /**
     * @type {HTMLElement[]}
     */
    tabs = [];

    /**
     * @type {string[]}
     */
    wecamData = [];

    /**
     * @type {undefined|number}
     */
    _tabTimer;

    /**
     * @type {undefined|number}
     */
    _loadingTimer;

    /**
     * 
     * @param {HTMLElement} modal 
     */
    constructor(modal) {
        this.modal = modal;
        this.modalButtons = Array.from(document.querySelectorAll('.header__webcam'));
        this.closeButton = this.modal ? this.modal.querySelector('.webcam-modal__close') : null;

        if (!this.modal || !this.modalButtons.length || !this.closeButton) {
            return;
        }
        this.contentElement = this.modal.querySelector('.webcam-modal__content');
        this.iframe = this.modal.querySelector('#webcam-iframe');
        this.tabs = Array.from(this.modal.querySelectorAll('.webcam-modal__tab '));

        if (!this.iframe || !this.tabs.length || !this.contentElement) {
            return;
        }

        this.findData();
        this.addListeners();
    }

    findData() {
        const scriptEl = this.modal.querySelector('#webcam-data');

        if (!scriptEl) {
            return;
        }

        try {
            this.wecamData = JSON.parse(scriptEl.textContent);
        } catch(error) {
            console.warn(error.message);
        }
    }

    addListeners() {
        this.modalButtons.forEach((b) => {
            b.addEventListener('click', (e) => {
                e.preventDefault();
                this.open();
            });
        });
        
        this.closeButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.close();
        });

        this.iframe.addEventListener('load', () => {
            if (this._loadingTimer) {
                clearTimeout(this._loadingTimer);
            }

            this._loadingTimer = setTimeout(() => {
                this.contentElement.classList.remove('loading');
            }, 300);
        });

        this.tabs.forEach(tab => {
            const tabIndex = +tab.dataset.tab;
            tab.addEventListener('click', () => {
                if (tab.classList.contains('active')) {
                    return;
                }

                this.setActiveTab(tabIndex);
            });
        });
    }

    /**
     * 
     * @param {number} index 
     */
    setActiveTab(index) {
        const url = this.wecamData[index] || false;

        if (!url) {
            return;
        }
        this.contentElement.classList.add('loading');
        this.iframe.src = url;

        this.tabs.forEach((t, i) => {
            t.classList.toggle('active', index === i);
            t.classList.remove('animate');
        });

        if (this._tabTimer) {
            clearTimeout(this._tabTimer);
        }

        this._tabTimer = setTimeout(() => {
            this.tabs[index].classList.add('animate');
        }, 200);
    }

    open() {
        this.modal.classList.add('opened');
    }

    close() {
        this.modal.classList.remove('opened');
    }
}
